import http, { IObjStr, IObjStrNum, IObjStrObj } from '@/utils/http';
const prefix = '/ysr-h5-app';
export interface propsList {
  id: string;
  textProName: string;
  applyFlag: string;
  textProLogo: string;
  agencyName?: string;
  platformCode: string;
  selected?: boolean;
  applySuccessFlag?: number;
  creditMultiplePushProtocol: IObjStr[];
  productOrgType?: string;
  creditProductType?: number | string;
  maxAmount?: string | number;
  businessType?: string | number;
  virtualUserSupported?: boolean | string | number;
}

/** 结果页-获取信贷产品 */
export const getOrderResultPage = (par?: IObjStrObj | string): Promise<propsList[]> => {
  // walletHttp.post<propsList[]>('/h5/0513/orderResultPage', {});
  if (par) {
    return http.post<propsList[]>(
      prefix + '/web/creditConversionControl/h5CreditMultiplePushRecommend',
      par as IObjStrObj
    );
  } else {
    return http.post<propsList[]>(
      prefix + '/web/creditConversionControl/h5CreditMultiplePushRecommend'
    );
  }
};

export const getCreditBuyingProductList = (par?: IObjStrObj | string): Promise<propsList> => {
  if (par) {
    return http.post<propsList>(
      prefix + '/web/creditConversionControl/getCreditBuyingProductList',
      par as IObjStrObj
    );
  } else {
    return http.post<propsList>(prefix + '/web/creditConversionControl/getCreditBuyingProductList');
  }
};
export const getCreditBuyingHalfProduct = (par?: IObjStrObj | string): Promise<propsList[]> => {
  if (par) {
    return http.post<propsList[]>(
      prefix + '/web/creditApiBuying/getCreditBuyingHalfProduct',
      par as IObjStrObj
    );
  } else {
    return http.post<propsList[]>(prefix + '/web/creditApiBuying/getCreditBuyingHalfProduct');
  }
};

export const getCreditBuyingApplyStatus = (): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/creditConversionControl/getCreditBuyingApplyStatus');

export interface LatestCreditAgencyOrder {
  agencyName?: string;
  agencyLogo?: string;
}

export interface LatestCreditAgencyOrderQuery {
  /** 金蝶进件流水号，取联登地址 orderNo */
  orderNo: string;
  /** 联登地址中的我方渠道 ID */
  channelId: number | string;
}

/**最近一笔信贷机构订单，用于等待接听页展示机构名和 logo*/
export const latestCreditAgencyOrder = (
  par: LatestCreditAgencyOrderQuery
): Promise<LatestCreditAgencyOrder> =>
  http.post<LatestCreditAgencyOrder>(prefix + '/web/walletOrder/latestCreditAgencyOrder', par);

/**落地页线索普通网贷产品匹配*/
export const clueOnlineLoanProductMatch = (): Promise<IObjStrObj> =>
  http.post<IObjStrObj>(prefix + '/web/creditConversionControl/clueOnlineLoanProductMatch');
/**保存普通网贷用户留资*/
export const saveOnlineCapital = (par: IObjStrObj): Promise<IObjStrObj> =>
  http.post<IObjStrObj>(prefix + '/web/creditConversionControl/saveOnlineCapital', par);
/**根据产品id获取普通网贷所有留资字段元数据*/
export const getOnlineCapitalFieldByProductId = (par: IObjStrObj): Promise<IObjStrObj> =>
  http.post<IObjStrObj>(
    prefix + '/web/creditConversionControl/getOnlineCapitalFieldByProductId',
    par
  );
